var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"version":"1.1","baseProfile":"full","xmlns":"http://www.w3.org/2000/svg","viewBox":"-55 -55 110 110","width":_vm.width}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }